import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpErrorResponseMessage } from 'src/app/enum/http-error-response-message';
import { DiaryService } from '../../services/api/diary/diary.service';
import { ResponseError } from '../utils/response-error';
import { ResponseSuccess } from '../utils/response-success';
import { addAllDiariesStore, DiaryActionTypes, GetAllDiaries } from './diary.action';

export type GetAllDiariesPayload = {
  isShareable?: number;
  isSubscribable?: number;
  isActive?: number;
  isPrivate?: number;
  studyId?: number;
  questionnaireId?: number;
};

@Injectable()
export class DiaryEffects {
  getAllDiaries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DiaryActionTypes.getAllDiariesType),
      map((action: GetAllDiaries) => action.payload),
      switchMap((payload: GetAllDiariesPayload) =>
        this.diaryService
          .getAllDiaries(
            payload.isShareable,
            payload.isSubscribable,
            payload.isActive,
            payload.isPrivate,
            payload.studyId,
            payload.questionnaireId
          )
          .pipe(
            switchMap((result) => {
              const actions = [];
              actions.push(addAllDiariesStore({ diaries: result.body.data }));
              actions.push(new ResponseSuccess(DiaryActionTypes.getAllDiariesSuccessType, result));
              return actions;
            }),
            catchError((err) =>
              of(
                new ResponseError(DiaryActionTypes.getAllDiariesErrorType, {
                  message: HttpErrorResponseMessage.genericUnknownError,
                  content: err,
                }),
              ),
            ),
          ),
      ),
    ),
  );

  constructor(private actions$: Actions, private diaryService: DiaryService) {}
}
